import { batch } from 'react-redux';
import { DateTimeService, lt, showSuccessAlert } from '@mews/framework';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction, notEmpty, localizedDateStringToDate, dateTimeToUtc } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import prefix from '../prefix';
import { setProfiles } from '../ducks/profiles';
import { setPreauthorizations, setPreauthorization } from '../ducks/preauthorizations';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '../selectors/session/enterprise';
import { getPaymentCardById, setPaymentCards } from '../ducks/paymentCards';
import { dispatchScopedGroupedEntityActions } from '../ducks/utils';

export const NAME = 'preauthorizations';

const PREAUTHORIZATION_ADD = prefix('PREAUTHORIZATION_ADD');

export const PREAUTHORIZATIONS_FETCH = prefix('PREAUTHORIZATIONS_FETCH');

export const addPreauthorization =
    ({
        customerId,
        amount,
        code,
        creditCardId,
        currency,
        isGateway,
        notes,
        receiptIdentifier,
        sequenceCode,
        expirationDate,
    }: $TSFixMe): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { container, appClockService }) => {
        const { appLocalizationComponent, preauthorizationComponent } = container();
        const { parseCurrencyValue, localizeCurrencyValue } = appLocalizationComponent;

        let expirationUtc;

        if (expirationDate) {
            const timezone = getCurrentEnterpriseIanaTimeZoneIdentifier(getState());
            const nowUtc = appClockService.getAppNowUtc();
            const dateTime = DateTimeService.fromUtc(nowUtc, timezone);
            const time = DateTimeService.toTime(dateTime);
            const chosenExpirationDate = localizedDateStringToDate(expirationDate);
            const expirationDateTime = DateTimeService.fromDateAndTime(chosenExpirationDate, time);
            expirationUtc = dateTimeToUtc(expirationDateTime);
        }

        const enterpriseId = getCurrentEnterpriseId();

        const payload = {
            customerId,
            amount: parseCurrencyValue(amount),
            code,
            creditCardId,
            currency,
            isGateway,
            notes,
            receiptIdentifier,
            sequenceCode,
            enterpriseId,
            expirationUtc,
        };
        const promise = preauthorizationComponent.add(payload).then((data: $TSFixMe) => {
            dispatch(setPreauthorization(data, customerId));

            const card = getPaymentCardById(getState(), { id: creditCardId, accountId: data.accountId });

            const localizedAmount = localizeCurrencyValue({
                value: data.amount,
                currency: data.currency,
            });

            showSuccessAlert({
                description: lt('CardPreauthorizationSuccessMessage', {
                    // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
                    cardLastDigits: card.lastDigits,
                    amount: localizedAmount,
                }),
            });

            return data;
        });

        return dispatch(createFetchAction(PREAUTHORIZATION_ADD, promise)).then(({ value }: $TSFixMe) => value);
    };

const fetch =
    (params: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { preauthorizationComponent } = container();
        const enterpriseId = getCurrentEnterpriseId();

        const promise = preauthorizationComponent.getAll({ ...params, enterpriseId }).then((data: $TSFixMe) => {
            const { preauthorizations, profiles, paymentCards } = data;

            batch(() => {
                if (notEmpty(preauthorizations)) {
                    dispatch(
                        dispatchScopedGroupedEntityActions({
                            entities: preauthorizations,
                            action: setPreauthorizations,
                            scopeName: 'accountId',
                        })
                    );
                }

                if (notEmpty(paymentCards)) {
                    dispatch(setPaymentCards(paymentCards));
                }

                if (notEmpty(profiles)) {
                    dispatch(setProfiles(profiles));
                }
            });

            return data;
        });

        return dispatch(createFetchAction(PREAUTHORIZATIONS_FETCH, promise));
    };

export const fetchPreauthorizationsByAccountIds = ({ accountIds, extent }: $TSFixMe) => fetch({ accountIds, extent });
